import { PRIMARY, makeThemeColor } from '@tornado-rdk/theme';
import { FONT, getFont } from '@tornado-rdk/typography';
import { makeDefaultStylingContext } from '../../utils/style';

export const defaultContext = makeDefaultStylingContext();

export const colors = {
  text: makeThemeColor(PRIMARY),
};

export const getInitialStyle = (context = defaultContext) => {
  const { screenSize, colorMode } = context;

  return {
    Title: {
      alpha: 0.8,
      color: colors.text[colorMode],
      text: {
        ...getFont(FONT.BERLIN_1, screenSize),
        maxLinesSuffix: '...',
        maxLines: 1,
      },
    },
    Details: {
      color: colors.text[colorMode],
      text: {
        ...getFont(FONT.OTTAWA_1, screenSize),
        maxLinesSuffix: '...',
        maxLines: 3,
      },
    },
    flex: {
      direction: 'column',
    },
  };
};
